import Konva from "konva";
import { Preloader } from "../../loader/Preloader";
import * as CanvasUtil from "../../util/CanvasUtil";
let callbackCount = 0;
let bgImg = null;
let bgKinsi = null;
let obj = {};
export function loadTabletBg(url, url2, bgLayer, width, height, callback) {
  const params = {
    x: width * 0.5 - 1920,
    y: height * 0.5 - 540,
    width: 3840,
    height: 1080
  };
  loadBg(url, params, bgLayer);
  loadBg(url2, params, bgLayer);
  bgLayer.batchDraw();
}
function loadBg(url, params, bgLayer){
  params.image = Preloader.getImg(url);
  const img = new Konva.Image(params);
  console.log("url", url, img.width());

  bgLayer.add(img);
}


import OreCanvas from "../draw/OreCanvas";
let tabletImage;
let tabletImageCanvas;

export function copyDrawingLayerToBg(srcCanvas, bgLayer, width, height) {
  if (!tabletImage)
  {
    tabletImageCanvas = new OreCanvas(srcCanvas.width, srcCanvas.height);
    const param = {
      image: tabletImageCanvas.canvas,
      x: (width - srcCanvas.width) * 0.5,
      y: (height - srcCanvas.height) * 0.5,
      width: srcCanvas.width,
      height: srcCanvas.height
    };
    tabletImage = new Konva.Image(param);
    bgLayer.add(tabletImage);
  }
  tabletImageCanvas.drawCanvas(srcCanvas);
  bgLayer.batchDraw();
}

export function addBgImg(url, restrictUrl, bgLayer, width, height, callback) {
  callbackCount = 0;
  Konva.Image.fromURL(url, img => {
    bgLayer.add(img);
    bgLayer.batchDraw();
    img.x((width - img.width()) * 0.5);
    img.y((height - img.height()) * 0.5);
    console.log("img.width()", img.width(), img.height());
    bgImg = img;
    multiCallback(callback, bgLayer, 1);
  });
  obj.bgLayer = bgLayer;
  obj.callback = callback;

  // loadResizedImg(restrictUrl);

  // Konva.Image.fromURL(restrictUrl, img => {
  //   bgLayer.add(img);
  //   bgKinsi = img;
  //   multiCallback(callback, bgLayer, 2);
  // });
}

function resizBgImg(bgImg) {
  bgImg;
}

function loadResizedImg(restrictUrl) {
  const img = document.createElement("img");
  // TODO: img loadのエラー時
  const handler = function() {
    resize(img);
    img.removeEventListener("load", handler);
  };
  img.addEventListener("load", handler, false);
  img.crossOrigin = "anonymous";
  img.src = restrictUrl;
}

export function trimImg(img, pos, crop, rect, ratio) {
  const { canvas, ctx } = createCanvas(rect.width, rect.height);
  let x = pos.x - (rect.width - crop.width) * 0.5;
  let y = pos.y - (rect.height - crop.height) * 0.5;

  CanvasUtil.drawImage(ctx, img, x, y, rect.width, ratio);

  const result = new Konva.Image({
    image: canvas,
    listening: false,
    hitGraphEnabled: false
  });
  return result;
}

function resize(img) {
  const { canvas, ctx } = createCanvas(img.width * 0.1, img.height * 0.1);
  ctx.drawImage(img, 0, 0, w, h);

  const resizedImg = createImg();
  const data = canvas.toDataURL("image/png");
  const handler = function() {
    const konvaImage = new Konva.Image({ image: resizedImg });
    obj.bgLayer.add(konvaImage);
    bgKinsi = konvaImage;
    multiCallback(obj.callback, obj.bgLayer, 2);
    // document.getElementById("testImageResize").appendChild(resizedImg);
    resizedImg.removeEventListener("load", handler);
  };

  resizedImg.addEventListener("load", handler, false);
  resizedImg.src = data;
}

function createCanvas(width, height) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = width;
  canvas.height = height;
  return { canvas, ctx };
}

function createImg() {
  const resizedImg = document.createElement("img");
  resizedImg.crossOrigin = "anonymous";
  resizedImg.width = w;
  resizedImg.height = h;
  return resizedImg;
}

function fixKinsi() {
  bgKinsi.width(bgImg.width());
  bgKinsi.height(bgImg.height());
  bgKinsi.x(bgImg.x());
  bgKinsi.y(bgImg.y());
  bgKinsi.zIndex(1);
  bgKinsi.opacity(0.4);
}

function multiCallback(callback, bgLayer, count) {
  callbackCount++;
  if (count == callbackCount) {
    if (bgKinsi) {
      fixKinsi();
    }
    resizBgImg(bgImg);
    bgLayer.batchDraw();
    callback(bgImg, bgKinsi);
  }
}
